import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize, getLocale } from '../../util/Localizer'
import { withStyles } from '@material-ui/core/styles'
import Config from '../../Config'
import Card from '@material-ui/core/Card'
import TitledLabel from '../../controls/TitledLabel'
import Columns from '../../styles/columns'
import Divider from '@material-ui/core/Divider'
import Loading from '../../widgets/Loading'
import Banking from '../../widgets/userProfile/Banking'
import maskStringValue from '../../util/MaskStringValue'
import FileUploadPreview from '../../widgets/SubmitAClaim/FileUploadPreview'
import { Colors } from '../../theme'
// redux
import { updateClaim } from '../../redux/actions/submitAClaimActions'
import { clearNavDialog } from '../../redux/actions/submitNavigationActions'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

class CertifcationAndAuthorization extends Component {
  componentDidMount () {
    this.props.setNext('submit')
    this.props.setPercent(90)
    this.props.updateUrl('')
    this.props.adjustScrollBar()
    this.props.clearNavDialog()

    if (this.props.claimObj && this.props.claimObj.claimSubmitType !== 'photoUpload') {
      this.clearFiles()
    }
  }

  addFile (file) {
    const claim = {
      ...this.props.claimObj,
      ImageContent: [ ...this.props.claimObj.ImageContent, file ]
    }
    this.props.updateClaim(claim)
  }

  clearFiles () {
    const claim = {
      ...this.props.claimObj,
      ImageContent: []
    }
    this.props.updateClaim(claim)
  }

  renderBanking () {
    const { classes = {} } = this.props

    if (this.props.memberSummary.bankingInformation) {
      const {
        bankTransitNumber = '',
        bankNumber = '',
        accountNumber = '',
        currency
      } = this.props.memberSummary.bankingInformation

      const maskedTransitNumber = maskStringValue(bankTransitNumber, -2)
      const maskedBankNumber = maskStringValue(bankNumber, -1)
      const maskedAccountNumber = maskStringValue(accountNumber, -3)

      return (
        <Row start='xs' className={classes.textAlignLeft}>
          <Col xs={12}>
            <h4 className={classes.primaryColor}>{localize('pages.SubmitAClaim.CertificationAndAuthorization.DirectDepositInformationTitle')}</h4>
            <p>{localize('pages.SubmitAClaim.CertificationAndAuthorization.VerifyYourBankingInformationText')}</p>
            <p>{localize('pages.SubmitAClaim.CertificationAndAuthorization.YourExplanationOfBenefitsWillBeAvailableText')}</p>
            <Row>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.TransitNumber' value={maskedTransitNumber} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.InstitutionNumber' value={maskedBankNumber} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.AccountNumber' value={maskedAccountNumber} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.Currency' value={currency} />
              </Col>
            </Row>
            <br />
            <Banking />
          </Col>
        </Row>
      )
    }
  }
  renderContactInfo () {
    const { classes = {} } = this.props
    const { showPhoneNumbers } = Config

    if (this.props.memberSummary) {
      let add = this.props.memberSummary.address
      let address = (<div>{add.addressLine1}<br />{add.city} {add.province}<br />{add.postalCode}</div>)
      return (
        <Row>
          <Col xs={12}>
            <Divider />
            <h4 className={classes.primaryColor}>{localize('pages.SubmitAClaim.CertificationAndAuthorization.PlanMemberContactInformationTitle')}</h4>
            <p>{localize('pages.SubmitAClaim.CertificationAndAuthorization.PlanMemberContactInformationText')}</p>
            <Row>
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.Address' value={address} />
              </Col>
              { showPhoneNumbers &&
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.Phone' value={this.props.memberSummary.phones} />
              </Col>}
              <Col {...Columns.max6}>
                <TitledLabel title='pages.SubmitAClaim.CertificationAndAuthorization.Email' value={this.props.memberSummary.email} />
              </Col>
            </Row>
          </Col>
        </Row>
      )
    }
  }
  renderAuthorization () {
    const { classes = {} } = this.props
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    const { content = '' } = contentItemText[loc] || {}
    return (
      <Row>
        <Col xs={12}>
          <br />
          <div className={classes.authContainer}>
            <div dangerouslySetInnerHTML={{ __html: content }}/>
          </div>
        </Col>
      </Row>
    )
  }

  renderUploadedFiles () {
    const { classes = {} } = this.props

    if (this.props.claimObj && this.props.claimObj.claimSubmitType === 'photoUpload') {
      const { ImageContent = [] } = this.props.claimObj
      return (
        <div>
          <Divider />
          <h4 className={ classes.primaryColor }>{localize('pages.SubmitAClaim.PhotoUpload.uploadedFiles')}</h4>
          <Row>
            {
              ImageContent.map((file, index) => {
                return (
                  <Col key={index} xs={3}>
                    <FileUploadPreview key={index} data={file} onSelectFile={this.addFile} />
                  </Col>
                )
              })
            }
          </Row>
        </div>
      )
    }
  }

  render () {
    const { classes = {} } = this.props

    return (
      <div>
        <Card className={classes.card}>
          <Row start='xs'>
            <Col xs={12}>
              <h3 className={ classes.textAlignLeft }>{localize('pages.SubmitAClaim.CertificationAndAuthorization.Title')}</h3>
              {this.props.isLoading ? <Loading /> : this.renderBanking()}
            </Col>
          </Row>
        </Card>
        <br />
        <Card className='submitCard'>
          <Row start='xs'>
            <Col xs={12}>
              {this.renderContactInfo()}
              {this.renderAuthorization()}
              {this.renderUploadedFiles()}
            </Col>
          </Row>
        </Card>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    memberSummary: state.memberSummaryReducer.memberSummary,
    isLoading: state.memberSummaryReducer.isLoading,
    memberError: state.memberSummaryReducer.error,
    banking: state.SubmitAClaimReducer.banking,
    claimObj: state.SubmitAClaimReducer.claimObj
  }
}

const ConnectedCertifcationAndAuthorization = connect(mapStateToProps, { updateClaim, clearNavDialog })(injectIntl(CertifcationAndAuthorization))

const Styles = {
  card: {
    padding: '0px 20px 30px 20px'
  },
  textAlignLeft: {
    textAlign: 'left'
  },
  primaryColor: {
    color: Colors.Palette.primaryColor
  },
  authContainer: {
    border: `1px solid ${Colors.Palette.borderColor}`,
    height: 300,
    overflowY: 'scroll',
    padding: 10
  }
}

export default withStyles(Styles)(ConnectedCertifcationAndAuthorization)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/CertifcationAndAuthorization.js